export default __webpack_public_path__ + "static/media/home-banner3.f11cafa3.png";